import { useContext, useMemo } from 'react';

import { Trans } from '@lingui/react/macro';

import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

import { ExternalPatientContext, ONBOARDING_VIDEO_KEY } from '../constants';

export const Onboarding = () => {
  const { trackEvent } = useTrackEvent();
  const externalPatientContext = useContext(ExternalPatientContext);

  // Check if MP4 is supported first, then fall back to WebM
  const canPlayMP4 = useMemo(() => {
    const video = document.createElement('video');
    return (
      video.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"') ===
        'probably' ||
      video.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"') ===
        'maybe' ||
      video.canPlayType('video/mp4; codecs="avc1.4D001E, mp4a.40.2"') ===
        'probably' ||
      video.canPlayType('video/mp4; codecs="avc1.4D001E, mp4a.40.2"') ===
        'maybe'
    );
  }, []);

  const handlePlay = () => {
    localStorage.setItem(ONBOARDING_VIDEO_KEY, 'true');
    trackEvent(mixpanelEvents.externalOnboardingVideoPlay, {
      ...externalPatientContext,
    });
  };

  return (
    <div className="vai-flex vai-flex-col vai-items-center vai-gap-5">
      <p className="vai-font-merriweather vai-font-bold vai-text-3xl vai-text-slate-900 vai-text-center">
        <Trans>Welcome to Detect AI, powered by VideaHealth</Trans>
      </p>
      <p className="vai-font-inter vai-text-navy-500">
        <Trans>
          Watch this quick 1-minute video to get started in no time.
        </Trans>
      </p>
      <div>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video onPlay={handlePlay} controls playsInline preload="metadata">
          {canPlayMP4 ? (
            <source
              src="https://videahealth-public-assets.s3.us-east-2.amazonaws.com/detectai-onboarding.mp4"
              type="video/mp4"
            />
          ) : (
            <source
              src="https://videahealth-public-assets.s3.us-east-2.amazonaws.com/detectai-onboarding.webm"
              type="video/webm"
            />
          )}
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};
